export default __webpack_public_path__ + "static/media/new_menu.84afedc6.svg";